module.exports = __webpack_public_path__ + "img/firstName.80c03748.svg";